<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :filter="filter"
      :pagination="pagination"
      resource="search_records"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { Message, MessageBox } from 'element-ui';
import { request, autoLoading } from 'beans-admin-plugin';

@Component
export default class Searchrecords extends Vue {

  pagination = {}

  filter = [
    {
      prop: 'keyword_cont',
      label: '关键字',
      form: {
        component: 'input',
        props: {
          placeholder: '请输入关键字'
        }
      }
    },
    {
      prop: 'enabled_eq',
      label: '小程序上是否显示',
      form: {
        component: 'select',
        props: {
          options: [
            {
              label: '是',
              value: true
            },
            {
              label: '否',
              value: false
            }
          ]
        }
      }
    }
  ]

  table = {
    data: []
  };

  get columns() {
    const _that = this;

    return [
      {
        prop: 'id',
        label: '编号',
      },
      {
        prop: 'keyword',
        label: '关键字',
        width: 300
      },
      {
        prop: 'count',
        label: '搜索次数',
        sort: 'order_by'
      },
      {
        prop: 'enabled',
        label: '小程序上是否显示',
        renderCell: 'bool'
      },
      {
        prop: 'action',
        label: '操作',
        width: 180,
        detail: true,
        extraAction(h, { row }) {
          const { enabled, id } = row;
          const handleCommand = async(title, action) => {
            await MessageBox.confirm(`确定${title}?`, `${title}`);
            await autoLoading(
              request.put(`/search_records/${id}`, { enabled: action === 'show' })
            );
            Message.success(`${title}成功`);
            _that.fetchData();
          }
          return [
            !enabled && {
              text: '小程序显示',
              handler: () => handleCommand('显示搜索记录', 'show')
            },
            enabled && {
              text: '小程序隐藏',
              handler: () => handleCommand('隐藏搜索记录', 'hide')
            },
          ]
        }
      }
    ];
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/search_records', { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }
}
</script>
